var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-button.ts
import "@adornis/ass/style";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { css } from "@adornis/chemistry/directives/css";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/chemistry/elements/components/x-link";
import { html, nothing } from "lit";
import { property } from "lit/decorators.js";
import { customElement } from "lit/decorators/custom-element.js";
import { geSpacing } from "../constants";
var buttonStyles = (host) => {
  const colors = host.colors;
  return {
    ":host([mode=action])": {
      background: colors.accent,
      color: colors.on.accent,
      transition: "box-shadow .12s ease",
      border: `1px solid ${colors.accent}`,
      textTransform: "uppercase"
    },
    ":host([mode=action][secondary])": { background: colors.secondary, color: colors.on.secondary, border: "none" },
    ":host([mode=action]:hover)": { boxShadow: host.shadows[1] },
    ":host([mode=action]:active)": { boxShadow: "none" },
    ":host([mode=action][tone=error])": { background: colors.tone.error, color: colors.on.tone.error },
    ":host([mode=text])": {
      background: "transparent",
      color: "unset",
      // textDecoration: 'underline',
      "#innerwrapper": {
        padding: "0"
      },
      "x-link": { padding: 0 }
    },
    ":host([mode=landing-text])": {
      background: "transparent",
      color: colors.accent,
      // textDecoration: 'underline',
      "#innerwrapper": {
        padding: "0"
      },
      "x-link": { padding: 0 }
    },
    ":host([mode=text][tone=error])": { color: colors.tone.error },
    ":host([mode=outline])": {
      background: "transparent",
      border: `1px solid ${colors.secondary}`,
      color: colors.secondary,
      textTransform: "uppercase"
    },
    ":host([mode=outline][tone=error])": { border: `1px solid #FF4B5B`, color: "#FF4B5B" },
    ":host([mode=fab])": {
      background: colors.accent,
      color: colors.on.accent,
      boxShadow: host.shadows[2],
      "#innerwrapper": {
        height: "50px",
        width: "50px",
        justifyContent: "center",
        alignItems: "center",
        padding: "0"
      },
      "x-icon": {
        fontSize: "1.8em"
      }
    },
    ":host([mode=fab][tone=error])": { background: colors.tone.error, color: colors.on.tone.error },
    ":host([mode=icon])": {
      background: "transparent",
      color: colors.dark,
      // border: `1px solid ${colors.dark}`,
      borderRadius: "50%",
      "#innerwrapper": {
        height: "25px",
        width: "25px",
        justifyContent: "center",
        alignItems: "center",
        padding: "0"
      },
      "x-icon": {
        fontSize: "18px"
      }
    },
    ":host([mode=icon][active])": {
      background: colors.accent,
      color: colors.on.accent
      // border: `1px solid ${colors.on.accent}`,
    },
    ":host": {
      height: "40px",
      display: "inline-block",
      borderRadius: host.sizes.borderRadiusSecondary,
      whiteSpace: "nowrap",
      userSelect: "none",
      cursor: "pointer",
      "#innerwrapper": { padding: `${geSpacing.sm} ${geSpacing.md}`, height: "100%" }
    },
    ":host([disabled])": { opacity: ".5", pointerEvents: "none" }
  };
};
var GEButton = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.styles = () => buttonStyles(this);
    this.href = "";
    this.icon = "";
    this.iconend = false;
    this.mode = "action";
    this.active = false;
    this.big = false;
  }
  render() {
    return html`
      <x-link ${css({ display: "flex", height: "100%" })} ${injectAttributesOf(this)}>
        <x-flex id="innerwrapper" ${css({ width: "100%", height: "100%" })} center>
          ${{
      icon: html` <x-icon> ${this.icon} </x-icon> `,
      fab: html`
              ${this.icon ? html`<x-icon> ${this.icon} </x-icon>` : nothing}
              <ge-h3 on-accent><slot></slot></ge-h3>
            `
    }[this.mode] || html`
            ${this.big ? html`
                  <ge-h4 color-unset>
                    <x-flex horizontal crossaxis-center space="xxs">
                      ${this.icon && !this.iconend ? html`<x-icon> ${this.icon} </x-icon>` : nothing}
                      <span
                        flex
                        ${css({
      /*textDecoration: state.mode === 'text' ? 'underline' : 'none',*/
      textAlign: "center"
    })}
                      >
                        <slot></slot>
                      </span>
                      ${this.icon && this.iconend ? html`<x-icon> ${this.icon} </x-icon>` : nothing}
                    </x-flex>
                  </ge-h4>
                ` : html`
                  <ge-text color-unset>
                    <x-flex horizontal crossaxis-center space="xs">
                      ${this.icon && !this.iconend ? html`<x-icon> ${this.icon} </x-icon>` : nothing}
                      <span
                        flex
                        ${css({
      /*textDecoration: state.mode === 'text' ? 'underline' : 'none',*/
      textAlign: "center"
    })}
                      >
                        <slot></slot>
                      </span>
                      ${this.icon && this.iconend ? html`<x-icon> ${this.icon} </x-icon>` : nothing}
                    </x-flex>
                  </ge-text>
                `}
          `}
        </x-flex>
      </x-link>
    `;
  }
};
__decorateClass([
  property({ reflect: true })
], GEButton.prototype, "href", 2);
__decorateClass([
  property({ reflect: true })
], GEButton.prototype, "icon", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], GEButton.prototype, "iconend", 2);
__decorateClass([
  property({ reflect: true })
], GEButton.prototype, "mode", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], GEButton.prototype, "active", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], GEButton.prototype, "big", 2);
GEButton = __decorateClass([
  customElement("ge-button")
], GEButton);
export {
  GEButton,
  buttonStyles
};
